export const MEDIA_SOURCE = Object.freeze({
  GSL: 'GSL',
});

export default MEDIA_SOURCE;
